/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ProductsService {
  /** @summary Get All */
  getAllProductsGet: {
    /** @summary Get All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetAllProductsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllProductsGetSchema,
        options: {
          parameters: GetAllProductsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllProductsGetData, GetAllProductsGetError>>
    ): Promise<RequestFnResponse<GetAllProductsGetData, GetAllProductsGetError>>;
    /** @summary Get All */
    getQueryKey(
      parameters: DeepReadonly<GetAllProductsGetParameters> | void
    ): ServiceOperationQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.productsService.getAllProductsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllProductsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        | (DeepReadonly<GetAllProductsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllProductsGetData,
          GetAllProductsGetError,
          TData,
          ServiceOperationQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllProductsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.productsService.getAllProductsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllProductsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        | (DeepReadonly<GetAllProductsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllProductsGetData,
          GetAllProductsGetError,
          TData,
          ServiceOperationQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllProductsGetError>>;
    /** @summary Get All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllProductsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.productsService.getAllProductsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllProductsGetParameters,
      TQueryFnData = GetAllProductsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllProductsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        | (DeepReadonly<GetAllProductsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllProductsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllProductsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.productsService.getAllProductsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllProductsGetParameters,
      TQueryFnData = GetAllProductsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllProductsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        | (DeepReadonly<GetAllProductsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllProductsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllProductsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllProductsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllProductsGetTotal = qraft.productsService.getAllProductsGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllProductsGetResults = qraft.productsService.getAllProductsGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllProductsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllProductsGetCombinedResults = qraft.productsService.getAllProductsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllProductsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllProductsGetSchema,
          GetAllProductsGetParameters,
          GetAllProductsGetData,
          GetAllProductsGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllProductsGetData, GetAllProductsGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetAllProductsGetData, GetAllProductsGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.productsService.getAllProductsGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllProductsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        | (DeepReadonly<GetAllProductsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllProductsGetData,
          GetAllProductsGetError,
          TData,
          ServiceOperationQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllProductsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.productsService.getAllProductsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAllProductsGetParameters, TData = GetAllProductsGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        | (DeepReadonly<GetAllProductsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllProductsGetData,
          GetAllProductsGetError,
          OperationInfiniteData<TData, GetAllProductsGetParameters>,
          ServiceOperationInfiniteQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllProductsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllProductsGetParameters>,
      OperationError<GetAllProductsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllProductsGetData = qraft.productsService.getAllProductsGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllProductsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllProductsGetCombinedData = qraft.productsService.getAllProductsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllProductsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllProductsGetSchema,
          GetAllProductsGetParameters,
          GetAllProductsGetData,
          GetAllProductsGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAllProductsGetData, GetAllProductsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetAllProductsGetData, GetAllProductsGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllProductsGetSchema,
        GetAllProductsGetData,
        GetAllProductsGetParameters,
        GetAllProductsGetError
      > | void
    ): Promise<GetAllProductsGetData>;
    /** @summary Get All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllProductsGetSchema,
        GetAllProductsGetData,
        GetAllProductsGetParameters,
        GetAllProductsGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllProductsGetSchema,
        GetAllProductsGetData,
        GetAllProductsGetParameters,
        GetAllProductsGetError
      > | void
    ): Promise<GetAllProductsGetData>;
    /** @summary Get All */
    fetchInfiniteQuery<TPageParam extends GetAllProductsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllProductsGetSchema,
        GetAllProductsGetData,
        GetAllProductsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllProductsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllProductsGetData, GetAllProductsGetParameters>>;
    /** @summary Get All */
    prefetchInfiniteQuery<TPageParam extends GetAllProductsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllProductsGetSchema,
        GetAllProductsGetData,
        GetAllProductsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllProductsGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureInfiniteQueryData<TPageParam extends GetAllProductsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllProductsGetSchema,
        GetAllProductsGetData,
        GetAllProductsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllProductsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllProductsGetData, GetAllProductsGetParameters>>;
    /** @summary Get All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        | (DeepReadonly<GetAllProductsGetParameters> | void)
    ): GetAllProductsGetData | undefined;
    /** @summary Get All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        | (DeepReadonly<GetAllProductsGetParameters> | void)
    ): OperationInfiniteData<GetAllProductsGetData, GetAllProductsGetParameters> | undefined;
    /** @summary Get All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>,
            data: NoInfer<OperationInfiniteData<GetAllProductsGetData, GetAllProductsGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>,
            data: GetAllProductsGetData | undefined,
          ]
        >;
    /** @summary Get All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        | (DeepReadonly<GetAllProductsGetParameters> | void)
    ): QueryState<GetAllProductsGetData, GetAllProductsGetError> | undefined;
    /** @summary Get All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllProductsGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<GetAllProductsGetData, GetAllProductsGetParameters>, GetAllProductsGetError>
      | undefined;
    /** @summary Get All */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllProductsGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>,
      updater: Updater<
        NoInfer<GetAllProductsGetData> | undefined,
        NoInfer<DeepReadonly<GetAllProductsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllProductsGetData | undefined;
    /** @summary Get All */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllProductsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetAllProductsGetSchema, GetAllProductsGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAllProductsGetData, GetAllProductsGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetAllProductsGetData, GetAllProductsGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllProductsGetData, GetAllProductsGetParameters> | undefined;
    /** @summary Get All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >,
      updater: Updater<NoInfer<GetAllProductsGetData> | undefined, NoInfer<GetAllProductsGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetAllProductsGetData | undefined>;
    /** @summary Get All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllProductsGetSchema,
        GetAllProductsGetData,
        TInfinite,
        GetAllProductsGetParameters,
        GetAllProductsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >
    ): void;
    /** @summary Get All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductsGetSchema,
            GetAllProductsGetData,
            TInfinite,
            GetAllProductsGetParameters,
            GetAllProductsGetError
          >
    ): number;
    schema: GetAllProductsGetSchema;
    types: {
      parameters: GetAllProductsGetParameters;
      data: GetAllProductsGetData;
      error: GetAllProductsGetError;
    };
  };
  /** @summary Create */
  createProductsPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateProductsPostBody, CreateProductsPostParameters, TMeta, TSignal>,
      client?: (
        schema: CreateProductsPostSchema,
        options: ServiceOperationMutationFnOptions<CreateProductsPostBody, CreateProductsPostParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateProductsPostData, CreateProductsPostError>>
    ): Promise<RequestFnResponse<CreateProductsPostData, CreateProductsPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateProductsPostParameters> | void
    ): ServiceOperationMutationKey<CreateProductsPostSchema, CreateProductsPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.createProductsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.createProductsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateProductsPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateProductsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateProductsPostSchema,
        CreateProductsPostData,
        CreateProductsPostParameters,
        TVariables,
        OperationError<CreateProductsPostError>,
        TContext
      >
    ): UseMutationResult<CreateProductsPostData, OperationError<CreateProductsPostError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.createProductsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.createProductsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateProductsPostBody, CreateProductsPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateProductsPostSchema,
        CreateProductsPostData,
        CreateProductsPostParameters,
        TVariables,
        OperationError<CreateProductsPostError>,
        TContext
      >
    ): UseMutationResult<CreateProductsPostData, OperationError<CreateProductsPostError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createProductsPostTotal = qraft.productsService.createProductsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createProductsPostTotal = qraft.productsService.createProductsPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateProductsPostBody,
            CreateProductsPostData,
            CreateProductsPostParameters,
            OperationError<CreateProductsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateProductsPostSchema,
            CreateProductsPostBody,
            CreateProductsPostData,
            CreateProductsPostParameters,
            OperationError<CreateProductsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createProductsPostPendingMutationVariables = qraft.productsService.createProductsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createProductsPostMutationData = qraft.productsService.createProductsPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateProductsPostData,
        OperationError<CreateProductsPostError>,
        MutationVariables<CreateProductsPostBody, CreateProductsPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateProductsPostBody,
            CreateProductsPostData,
            CreateProductsPostParameters,
            OperationError<CreateProductsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateProductsPostSchema,
            CreateProductsPostBody,
            CreateProductsPostData,
            CreateProductsPostParameters,
            OperationError<CreateProductsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateProductsPostData,
          OperationError<CreateProductsPostError>,
          MutationVariables<CreateProductsPostBody, CreateProductsPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateProductsPostBody,
            CreateProductsPostData,
            CreateProductsPostParameters,
            OperationError<CreateProductsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateProductsPostSchema,
            CreateProductsPostBody,
            CreateProductsPostData,
            CreateProductsPostParameters,
            OperationError<CreateProductsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.productsService.createProductsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.productsService.createProductsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateProductsPostBody,
              CreateProductsPostData,
              CreateProductsPostParameters,
              OperationError<CreateProductsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateProductsPostSchema,
              CreateProductsPostBody,
              CreateProductsPostData,
              CreateProductsPostParameters,
              OperationError<CreateProductsPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateProductsPostData,
            CreateProductsPostError,
            MutationVariables<CreateProductsPostBody, CreateProductsPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateProductsPostBody,
              CreateProductsPostData,
              CreateProductsPostParameters,
              OperationError<CreateProductsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateProductsPostSchema,
              CreateProductsPostBody,
              CreateProductsPostData,
              CreateProductsPostParameters,
              OperationError<CreateProductsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateProductsPostData,
          CreateProductsPostError,
          MutationVariables<CreateProductsPostBody, CreateProductsPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateProductsPostSchema;
    types: {
      parameters: CreateProductsPostParameters;
      data: CreateProductsPostData;
      error: CreateProductsPostError;
      body: CreateProductsPostBody;
    };
  };
  /** @summary Get */
  getProductsProductIdGet: {
    /** @summary Get */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetProductsProductIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetProductsProductIdGetSchema,
        options: {
          parameters: GetProductsProductIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetProductsProductIdGetData, GetProductsProductIdGetError>>
    ): Promise<RequestFnResponse<GetProductsProductIdGetData, GetProductsProductIdGetError>>;
    /** @summary Get */
    getQueryKey(
      parameters: DeepReadonly<GetProductsProductIdGetParameters>
    ): ServiceOperationQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.productsService.getProductsProductIdGet.useQuery({
     *     path: {
     *         product_id: productId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetProductsProductIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
        | DeepReadonly<GetProductsProductIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetProductsProductIdGetData,
          GetProductsProductIdGetError,
          TData,
          ServiceOperationQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetProductsProductIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.productsService.getProductsProductIdGet.useQuery({
     *     path: {
     *         product_id: productId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetProductsProductIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
        | DeepReadonly<GetProductsProductIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetProductsProductIdGetData,
          GetProductsProductIdGetError,
          TData,
          ServiceOperationQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetProductsProductIdGetError>>;
    /** @summary Get */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetProductsProductIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.productsService.getProductsProductIdGet.useInfiniteQuery({
     *     path: {
     *         product_id: productId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetProductsProductIdGetParameters,
      TQueryFnData = GetProductsProductIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetProductsProductIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
        | DeepReadonly<GetProductsProductIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetProductsProductIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetProductsProductIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.productsService.getProductsProductIdGet.useInfiniteQuery({
     *     path: {
     *         product_id: productId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetProductsProductIdGetParameters,
      TQueryFnData = GetProductsProductIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetProductsProductIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
        | DeepReadonly<GetProductsProductIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetProductsProductIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetProductsProductIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetProductsProductIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getProductsProductIdGetTotal = qraft.productsService.getProductsProductIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getProductsProductIdGetByParametersTotal = qraft.productsService.getProductsProductIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             product_id: productId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >
        | QueryFiltersByQueryKey<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getProductsProductIdGetResults = qraft.productsService.getProductsProductIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 product_id: productId1
     *             }
     *         },
     *         {
     *             path: {
     *                 product_id: productId2
     *             }
     *         }
     *     ]
     * });
     * getProductsProductIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getProductsProductIdGetCombinedResults = qraft.productsService.getProductsProductIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 product_id: productId1
     *             }
     *         },
     *         {
     *             path: {
     *                 product_id: productId2
     *             }
     *         }
     *     ]
     * });
     * getProductsProductIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetProductsProductIdGetSchema,
          GetProductsProductIdGetParameters,
          GetProductsProductIdGetData,
          GetProductsProductIdGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetProductsProductIdGetData, GetProductsProductIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetProductsProductIdGetData, GetProductsProductIdGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.productsService.getProductsProductIdGet.useSuspenseQuery({
     *     path: {
     *         product_id: productId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetProductsProductIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
        | DeepReadonly<GetProductsProductIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetProductsProductIdGetData,
          GetProductsProductIdGetError,
          TData,
          ServiceOperationQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetProductsProductIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.productsService.getProductsProductIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         product_id: productId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetProductsProductIdGetParameters, TData = GetProductsProductIdGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
        | DeepReadonly<GetProductsProductIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetProductsProductIdGetData,
          GetProductsProductIdGetError,
          OperationInfiniteData<TData, GetProductsProductIdGetParameters>,
          ServiceOperationInfiniteQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetProductsProductIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetProductsProductIdGetParameters>,
      OperationError<GetProductsProductIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getProductsProductIdGetData = qraft.productsService.getProductsProductIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 product_id: productId1
     *             }
     *         },
     *         {
     *             path: {
     *                 product_id: productId2
     *             }
     *         }
     *     ]
     * });
     * getProductsProductIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getProductsProductIdGetCombinedData = qraft.productsService.getProductsProductIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 product_id: productId1
     *             }
     *         },
     *         {
     *             path: {
     *                 product_id: productId2
     *             }
     *         }
     *     ]
     * });
     * getProductsProductIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetProductsProductIdGetSchema,
          GetProductsProductIdGetParameters,
          GetProductsProductIdGetData,
          GetProductsProductIdGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetProductsProductIdGetData, GetProductsProductIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<GetProductsProductIdGetData, GetProductsProductIdGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetProductsProductIdGetSchema,
        GetProductsProductIdGetData,
        GetProductsProductIdGetParameters,
        GetProductsProductIdGetError
      >
    ): Promise<GetProductsProductIdGetData>;
    /** @summary Get */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetProductsProductIdGetSchema,
        GetProductsProductIdGetData,
        GetProductsProductIdGetParameters,
        GetProductsProductIdGetError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetProductsProductIdGetSchema,
        GetProductsProductIdGetData,
        GetProductsProductIdGetParameters,
        GetProductsProductIdGetError
      >
    ): Promise<GetProductsProductIdGetData>;
    /** @summary Get */
    fetchInfiniteQuery<TPageParam extends GetProductsProductIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetProductsProductIdGetSchema,
        GetProductsProductIdGetData,
        GetProductsProductIdGetParameters,
        DeepReadonly<TPageParam>,
        GetProductsProductIdGetError
      >
    ): Promise<OperationInfiniteData<GetProductsProductIdGetData, GetProductsProductIdGetParameters>>;
    /** @summary Get */
    prefetchInfiniteQuery<TPageParam extends GetProductsProductIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetProductsProductIdGetSchema,
        GetProductsProductIdGetData,
        GetProductsProductIdGetParameters,
        DeepReadonly<TPageParam>,
        GetProductsProductIdGetError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureInfiniteQueryData<TPageParam extends GetProductsProductIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetProductsProductIdGetSchema,
        GetProductsProductIdGetData,
        GetProductsProductIdGetParameters,
        DeepReadonly<TPageParam>,
        GetProductsProductIdGetError
      >
    ): Promise<OperationInfiniteData<GetProductsProductIdGetData, GetProductsProductIdGetParameters>>;
    /** @summary Get */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
        | DeepReadonly<GetProductsProductIdGetParameters>
    ): GetProductsProductIdGetData | undefined;
    /** @summary Get */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
        | DeepReadonly<GetProductsProductIdGetParameters>
    ): OperationInfiniteData<GetProductsProductIdGetData, GetProductsProductIdGetParameters> | undefined;
    /** @summary Get */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >
        | QueryFiltersByQueryKey<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetProductsProductIdGetSchema,
              GetProductsProductIdGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<GetProductsProductIdGetData, GetProductsProductIdGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>,
            data: GetProductsProductIdGetData | undefined,
          ]
        >;
    /** @summary Get */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
        | DeepReadonly<GetProductsProductIdGetParameters>
    ): QueryState<GetProductsProductIdGetData, GetProductsProductIdGetError> | undefined;
    /** @summary Get */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetProductsProductIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>
    ):
      | QueryState<
          OperationInfiniteData<GetProductsProductIdGetData, GetProductsProductIdGetParameters>,
          GetProductsProductIdGetError
        >
      | undefined;
    /** @summary Get */
    setQueryData(
      parameters:
        | DeepReadonly<GetProductsProductIdGetParameters>
        | ServiceOperationQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>,
      updater: Updater<
        NoInfer<GetProductsProductIdGetData> | undefined,
        NoInfer<DeepReadonly<GetProductsProductIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetProductsProductIdGetData | undefined;
    /** @summary Get */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetProductsProductIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetProductsProductIdGetSchema, GetProductsProductIdGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetProductsProductIdGetData, GetProductsProductIdGetParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<GetProductsProductIdGetData, GetProductsProductIdGetParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetProductsProductIdGetData, GetProductsProductIdGetParameters> | undefined;
    /** @summary Get */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >
        | QueryFiltersByQueryKey<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >,
      updater: Updater<
        NoInfer<GetProductsProductIdGetData> | undefined,
        NoInfer<GetProductsProductIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetProductsProductIdGetData | undefined>;
    /** @summary Get */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetProductsProductIdGetSchema,
        GetProductsProductIdGetData,
        TInfinite,
        GetProductsProductIdGetParameters,
        GetProductsProductIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >
        | QueryFiltersByQueryKey<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >
        | QueryFiltersByQueryKey<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >
        | QueryFiltersByQueryKey<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >
    ): void;
    /** @summary Get */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >
        | QueryFiltersByQueryKey<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >
        | QueryFiltersByQueryKey<
            GetProductsProductIdGetSchema,
            GetProductsProductIdGetData,
            TInfinite,
            GetProductsProductIdGetParameters,
            GetProductsProductIdGetError
          >
    ): number;
    schema: GetProductsProductIdGetSchema;
    types: {
      parameters: GetProductsProductIdGetParameters;
      data: GetProductsProductIdGetData;
      error: GetProductsProductIdGetError;
    };
  };
  /** @summary Update */
  updateProductsProductIdPatch: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateProductsProductIdPatchBody,
        UpdateProductsProductIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateProductsProductIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateProductsProductIdPatchBody,
          UpdateProductsProductIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateProductsProductIdPatchData, UpdateProductsProductIdPatchError>>
    ): Promise<RequestFnResponse<UpdateProductsProductIdPatchData, UpdateProductsProductIdPatchError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateProductsProductIdPatchParameters> | void
    ): ServiceOperationMutationKey<UpdateProductsProductIdPatchSchema, UpdateProductsProductIdPatchParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.updateProductsProductIdPatch.useMutation({
     *     path: {
     *         product_id: productId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.updateProductsProductIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         product_id: productId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateProductsProductIdPatchBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateProductsProductIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateProductsProductIdPatchSchema,
        UpdateProductsProductIdPatchData,
        UpdateProductsProductIdPatchParameters,
        TVariables,
        OperationError<UpdateProductsProductIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateProductsProductIdPatchData,
      OperationError<UpdateProductsProductIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.updateProductsProductIdPatch.useMutation({
     *     path: {
     *         product_id: productId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.updateProductsProductIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         product_id: productId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateProductsProductIdPatchBody, UpdateProductsProductIdPatchParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateProductsProductIdPatchSchema,
        UpdateProductsProductIdPatchData,
        UpdateProductsProductIdPatchParameters,
        TVariables,
        OperationError<UpdateProductsProductIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateProductsProductIdPatchData,
      OperationError<UpdateProductsProductIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateProductsProductIdPatchTotal = qraft.productsService.updateProductsProductIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateProductsProductIdPatchTotal = qraft.productsService.updateProductsProductIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             product_id: productId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateProductsProductIdPatchBody,
            UpdateProductsProductIdPatchData,
            UpdateProductsProductIdPatchParameters,
            OperationError<UpdateProductsProductIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateProductsProductIdPatchSchema,
            UpdateProductsProductIdPatchBody,
            UpdateProductsProductIdPatchData,
            UpdateProductsProductIdPatchParameters,
            OperationError<UpdateProductsProductIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateProductsProductIdPatchPendingMutationVariables = qraft.productsService.updateProductsProductIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateProductsProductIdPatchMutationData = qraft.productsService.updateProductsProductIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 product_id: productId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateProductsProductIdPatchData,
        OperationError<UpdateProductsProductIdPatchError>,
        MutationVariables<UpdateProductsProductIdPatchBody, UpdateProductsProductIdPatchParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateProductsProductIdPatchBody,
            UpdateProductsProductIdPatchData,
            UpdateProductsProductIdPatchParameters,
            OperationError<UpdateProductsProductIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateProductsProductIdPatchSchema,
            UpdateProductsProductIdPatchBody,
            UpdateProductsProductIdPatchData,
            UpdateProductsProductIdPatchParameters,
            OperationError<UpdateProductsProductIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateProductsProductIdPatchData,
          OperationError<UpdateProductsProductIdPatchError>,
          MutationVariables<UpdateProductsProductIdPatchBody, UpdateProductsProductIdPatchParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateProductsProductIdPatchBody,
            UpdateProductsProductIdPatchData,
            UpdateProductsProductIdPatchParameters,
            OperationError<UpdateProductsProductIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateProductsProductIdPatchSchema,
            UpdateProductsProductIdPatchBody,
            UpdateProductsProductIdPatchData,
            UpdateProductsProductIdPatchParameters,
            OperationError<UpdateProductsProductIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.productsService.updateProductsProductIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             product_id: productId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.productsService.updateProductsProductIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateProductsProductIdPatchBody,
              UpdateProductsProductIdPatchData,
              UpdateProductsProductIdPatchParameters,
              OperationError<UpdateProductsProductIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateProductsProductIdPatchSchema,
              UpdateProductsProductIdPatchBody,
              UpdateProductsProductIdPatchData,
              UpdateProductsProductIdPatchParameters,
              OperationError<UpdateProductsProductIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateProductsProductIdPatchData,
            UpdateProductsProductIdPatchError,
            MutationVariables<UpdateProductsProductIdPatchBody, UpdateProductsProductIdPatchParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateProductsProductIdPatchBody,
              UpdateProductsProductIdPatchData,
              UpdateProductsProductIdPatchParameters,
              OperationError<UpdateProductsProductIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateProductsProductIdPatchSchema,
              UpdateProductsProductIdPatchBody,
              UpdateProductsProductIdPatchData,
              UpdateProductsProductIdPatchParameters,
              OperationError<UpdateProductsProductIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateProductsProductIdPatchData,
          UpdateProductsProductIdPatchError,
          MutationVariables<UpdateProductsProductIdPatchBody, UpdateProductsProductIdPatchParameters>,
          TContext
        >
      >;
    };
    schema: UpdateProductsProductIdPatchSchema;
    types: {
      parameters: UpdateProductsProductIdPatchParameters;
      data: UpdateProductsProductIdPatchData;
      error: UpdateProductsProductIdPatchError;
      body: UpdateProductsProductIdPatchBody;
    };
  };
  /** @summary Delete */
  deleteProductsProductIdDelete: {
    /** @summary Delete */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteProductsProductIdDeleteBody,
        DeleteProductsProductIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteProductsProductIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteProductsProductIdDeleteBody,
          DeleteProductsProductIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<DeleteProductsProductIdDeleteData, DeleteProductsProductIdDeleteError>>
    ): Promise<RequestFnResponse<DeleteProductsProductIdDeleteData, DeleteProductsProductIdDeleteError>>;
    /** @summary Delete */
    getMutationKey(
      parameters: DeepReadonly<DeleteProductsProductIdDeleteParameters> | void
    ): ServiceOperationMutationKey<DeleteProductsProductIdDeleteSchema, DeleteProductsProductIdDeleteParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.deleteProductsProductIdDelete.useMutation({
     *     path: {
     *         product_id: productId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.deleteProductsProductIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         product_id: productId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends DeleteProductsProductIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<DeleteProductsProductIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteProductsProductIdDeleteSchema,
        DeleteProductsProductIdDeleteData,
        DeleteProductsProductIdDeleteParameters,
        TVariables,
        OperationError<DeleteProductsProductIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteProductsProductIdDeleteData,
      OperationError<DeleteProductsProductIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.deleteProductsProductIdDelete.useMutation({
     *     path: {
     *         product_id: productId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.deleteProductsProductIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         product_id: productId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<DeleteProductsProductIdDeleteBody, DeleteProductsProductIdDeleteParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteProductsProductIdDeleteSchema,
        DeleteProductsProductIdDeleteData,
        DeleteProductsProductIdDeleteParameters,
        TVariables,
        OperationError<DeleteProductsProductIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteProductsProductIdDeleteData,
      OperationError<DeleteProductsProductIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteProductsProductIdDeleteTotal = qraft.productsService.deleteProductsProductIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteProductsProductIdDeleteTotal = qraft.productsService.deleteProductsProductIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             product_id: productId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteProductsProductIdDeleteBody,
            DeleteProductsProductIdDeleteData,
            DeleteProductsProductIdDeleteParameters,
            OperationError<DeleteProductsProductIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteProductsProductIdDeleteSchema,
            DeleteProductsProductIdDeleteBody,
            DeleteProductsProductIdDeleteData,
            DeleteProductsProductIdDeleteParameters,
            OperationError<DeleteProductsProductIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteProductsProductIdDeletePendingMutationVariables = qraft.productsService.deleteProductsProductIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteProductsProductIdDeleteMutationData = qraft.productsService.deleteProductsProductIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 product_id: productId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteProductsProductIdDeleteData,
        OperationError<DeleteProductsProductIdDeleteError>,
        MutationVariables<DeleteProductsProductIdDeleteBody, DeleteProductsProductIdDeleteParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteProductsProductIdDeleteBody,
            DeleteProductsProductIdDeleteData,
            DeleteProductsProductIdDeleteParameters,
            OperationError<DeleteProductsProductIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteProductsProductIdDeleteSchema,
            DeleteProductsProductIdDeleteBody,
            DeleteProductsProductIdDeleteData,
            DeleteProductsProductIdDeleteParameters,
            OperationError<DeleteProductsProductIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteProductsProductIdDeleteData,
          OperationError<DeleteProductsProductIdDeleteError>,
          MutationVariables<DeleteProductsProductIdDeleteBody, DeleteProductsProductIdDeleteParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Delete */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteProductsProductIdDeleteBody,
            DeleteProductsProductIdDeleteData,
            DeleteProductsProductIdDeleteParameters,
            OperationError<DeleteProductsProductIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteProductsProductIdDeleteSchema,
            DeleteProductsProductIdDeleteBody,
            DeleteProductsProductIdDeleteData,
            DeleteProductsProductIdDeleteParameters,
            OperationError<DeleteProductsProductIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.productsService.deleteProductsProductIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             product_id: productId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.productsService.deleteProductsProductIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteProductsProductIdDeleteBody,
              DeleteProductsProductIdDeleteData,
              DeleteProductsProductIdDeleteParameters,
              OperationError<DeleteProductsProductIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteProductsProductIdDeleteSchema,
              DeleteProductsProductIdDeleteBody,
              DeleteProductsProductIdDeleteData,
              DeleteProductsProductIdDeleteParameters,
              OperationError<DeleteProductsProductIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteProductsProductIdDeleteData,
            DeleteProductsProductIdDeleteError,
            MutationVariables<DeleteProductsProductIdDeleteBody, DeleteProductsProductIdDeleteParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteProductsProductIdDeleteBody,
              DeleteProductsProductIdDeleteData,
              DeleteProductsProductIdDeleteParameters,
              OperationError<DeleteProductsProductIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteProductsProductIdDeleteSchema,
              DeleteProductsProductIdDeleteBody,
              DeleteProductsProductIdDeleteData,
              DeleteProductsProductIdDeleteParameters,
              OperationError<DeleteProductsProductIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteProductsProductIdDeleteData,
          DeleteProductsProductIdDeleteError,
          MutationVariables<DeleteProductsProductIdDeleteBody, DeleteProductsProductIdDeleteParameters>,
          TContext
        >
      >;
    };
    schema: DeleteProductsProductIdDeleteSchema;
    types: {
      parameters: DeleteProductsProductIdDeleteParameters;
      data: DeleteProductsProductIdDeleteData;
      error: DeleteProductsProductIdDeleteError;
      body: DeleteProductsProductIdDeleteBody;
    };
  };
  /**
   * @summary Calculate Dilution Rate
   * @description Calculate dilution rate from mix ratio values.
   */
  calculateDilutionRateProductsCalculateDilutionRatePost: {
    /**
     * @summary Calculate Dilution Rate
     * @description Calculate dilution rate from mix ratio values.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CalculateDilutionRateProductsCalculateDilutionRatePostBody,
        CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CalculateDilutionRateProductsCalculateDilutionRatePostSchema,
        options: ServiceOperationMutationFnOptions<
          CalculateDilutionRateProductsCalculateDilutionRatePostBody,
          CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CalculateDilutionRateProductsCalculateDilutionRatePostData,
          CalculateDilutionRateProductsCalculateDilutionRatePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CalculateDilutionRateProductsCalculateDilutionRatePostData,
        CalculateDilutionRateProductsCalculateDilutionRatePostError
      >
    >;
    /**
     * @summary Calculate Dilution Rate
     * @description Calculate dilution rate from mix ratio values.
     */
    getMutationKey(
      parameters: DeepReadonly<CalculateDilutionRateProductsCalculateDilutionRatePostParameters> | void
    ): ServiceOperationMutationKey<
      CalculateDilutionRateProductsCalculateDilutionRatePostSchema,
      CalculateDilutionRateProductsCalculateDilutionRatePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Calculate Dilution Rate
     * @description Calculate dilution rate from mix ratio values.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.calculateDilutionRateProductsCalculateDilutionRatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.calculateDilutionRateProductsCalculateDilutionRatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CalculateDilutionRateProductsCalculateDilutionRatePostBody, TContext = unknown>(
      parameters: DeepReadonly<CalculateDilutionRateProductsCalculateDilutionRatePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CalculateDilutionRateProductsCalculateDilutionRatePostSchema,
        CalculateDilutionRateProductsCalculateDilutionRatePostData,
        CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
        TVariables,
        OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
        TContext
      >
    ): UseMutationResult<
      CalculateDilutionRateProductsCalculateDilutionRatePostData,
      OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Calculate Dilution Rate
     * @description Calculate dilution rate from mix ratio values.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.calculateDilutionRateProductsCalculateDilutionRatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productsService.calculateDilutionRateProductsCalculateDilutionRatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CalculateDilutionRateProductsCalculateDilutionRatePostBody,
        CalculateDilutionRateProductsCalculateDilutionRatePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CalculateDilutionRateProductsCalculateDilutionRatePostSchema,
        CalculateDilutionRateProductsCalculateDilutionRatePostData,
        CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
        TVariables,
        OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
        TContext
      >
    ): UseMutationResult<
      CalculateDilutionRateProductsCalculateDilutionRatePostData,
      OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Calculate Dilution Rate
     * @description Calculate dilution rate from mix ratio values.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const calculateDilutionRateProductsCalculateDilutionRatePostTotal = qraft.productsService.calculateDilutionRateProductsCalculateDilutionRatePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const calculateDilutionRateProductsCalculateDilutionRatePostTotal = qraft.productsService.calculateDilutionRateProductsCalculateDilutionRatePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CalculateDilutionRateProductsCalculateDilutionRatePostBody,
            CalculateDilutionRateProductsCalculateDilutionRatePostData,
            CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
            OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CalculateDilutionRateProductsCalculateDilutionRatePostSchema,
            CalculateDilutionRateProductsCalculateDilutionRatePostBody,
            CalculateDilutionRateProductsCalculateDilutionRatePostData,
            CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
            OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Calculate Dilution Rate
     * @description Calculate dilution rate from mix ratio values.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const calculateDilutionRateProductsCalculateDilutionRatePostPendingMutationVariables = qraft.productsService.calculateDilutionRateProductsCalculateDilutionRatePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const calculateDilutionRateProductsCalculateDilutionRatePostMutationData = qraft.productsService.calculateDilutionRateProductsCalculateDilutionRatePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CalculateDilutionRateProductsCalculateDilutionRatePostData,
        OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
        MutationVariables<
          CalculateDilutionRateProductsCalculateDilutionRatePostBody,
          CalculateDilutionRateProductsCalculateDilutionRatePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CalculateDilutionRateProductsCalculateDilutionRatePostBody,
            CalculateDilutionRateProductsCalculateDilutionRatePostData,
            CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
            OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CalculateDilutionRateProductsCalculateDilutionRatePostSchema,
            CalculateDilutionRateProductsCalculateDilutionRatePostBody,
            CalculateDilutionRateProductsCalculateDilutionRatePostData,
            CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
            OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CalculateDilutionRateProductsCalculateDilutionRatePostData,
          OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
          MutationVariables<
            CalculateDilutionRateProductsCalculateDilutionRatePostBody,
            CalculateDilutionRateProductsCalculateDilutionRatePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Calculate Dilution Rate
     * @description Calculate dilution rate from mix ratio values.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CalculateDilutionRateProductsCalculateDilutionRatePostBody,
            CalculateDilutionRateProductsCalculateDilutionRatePostData,
            CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
            OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CalculateDilutionRateProductsCalculateDilutionRatePostSchema,
            CalculateDilutionRateProductsCalculateDilutionRatePostBody,
            CalculateDilutionRateProductsCalculateDilutionRatePostData,
            CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
            OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Calculate Dilution Rate
     * @description Calculate dilution rate from mix ratio values.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.productsService.calculateDilutionRateProductsCalculateDilutionRatePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.productsService.calculateDilutionRateProductsCalculateDilutionRatePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CalculateDilutionRateProductsCalculateDilutionRatePostBody,
              CalculateDilutionRateProductsCalculateDilutionRatePostData,
              CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
              OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CalculateDilutionRateProductsCalculateDilutionRatePostSchema,
              CalculateDilutionRateProductsCalculateDilutionRatePostBody,
              CalculateDilutionRateProductsCalculateDilutionRatePostData,
              CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
              OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
              TContext
            >
      ):
        | Mutation<
            CalculateDilutionRateProductsCalculateDilutionRatePostData,
            CalculateDilutionRateProductsCalculateDilutionRatePostError,
            MutationVariables<
              CalculateDilutionRateProductsCalculateDilutionRatePostBody,
              CalculateDilutionRateProductsCalculateDilutionRatePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CalculateDilutionRateProductsCalculateDilutionRatePostBody,
              CalculateDilutionRateProductsCalculateDilutionRatePostData,
              CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
              OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CalculateDilutionRateProductsCalculateDilutionRatePostSchema,
              CalculateDilutionRateProductsCalculateDilutionRatePostBody,
              CalculateDilutionRateProductsCalculateDilutionRatePostData,
              CalculateDilutionRateProductsCalculateDilutionRatePostParameters,
              OperationError<CalculateDilutionRateProductsCalculateDilutionRatePostError>,
              TContext
            >
      ): Array<
        Mutation<
          CalculateDilutionRateProductsCalculateDilutionRatePostData,
          CalculateDilutionRateProductsCalculateDilutionRatePostError,
          MutationVariables<
            CalculateDilutionRateProductsCalculateDilutionRatePostBody,
            CalculateDilutionRateProductsCalculateDilutionRatePostParameters
          >,
          TContext
        >
      >;
    };
    schema: CalculateDilutionRateProductsCalculateDilutionRatePostSchema;
    types: {
      parameters: CalculateDilutionRateProductsCalculateDilutionRatePostParameters;
      data: CalculateDilutionRateProductsCalculateDilutionRatePostData;
      error: CalculateDilutionRateProductsCalculateDilutionRatePostError;
      body: CalculateDilutionRateProductsCalculateDilutionRatePostBody;
    };
  };
}
/** @summary Get All */
export const getAllProductsGet = {
  schema: {
    method: 'get',
    url: '/products',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllProductsGetSchema;
  [QraftServiceOperationsToken]: ProductsService['getAllProductsGet'];
};
/** @summary Create */
export const createProductsPost = {
  schema: {
    method: 'post',
    url: '/products',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateProductsPostSchema;
  [QraftServiceOperationsToken]: ProductsService['createProductsPost'];
};
/** @summary Get */
export const getProductsProductIdGet = {
  schema: {
    method: 'get',
    url: '/products/{product_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetProductsProductIdGetSchema;
  [QraftServiceOperationsToken]: ProductsService['getProductsProductIdGet'];
};
/** @summary Update */
export const updateProductsProductIdPatch = {
  schema: {
    method: 'patch',
    url: '/products/{product_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateProductsProductIdPatchSchema;
  [QraftServiceOperationsToken]: ProductsService['updateProductsProductIdPatch'];
};
/** @summary Delete */
export const deleteProductsProductIdDelete = {
  schema: {
    method: 'delete',
    url: '/products/{product_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: DeleteProductsProductIdDeleteSchema;
  [QraftServiceOperationsToken]: ProductsService['deleteProductsProductIdDelete'];
};
/**
 * @summary Calculate Dilution Rate
 * @description Calculate dilution rate from mix ratio values.
 */
export const calculateDilutionRateProductsCalculateDilutionRatePost = {
  schema: {
    method: 'post',
    url: '/products/calculate_dilution_rate',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CalculateDilutionRateProductsCalculateDilutionRatePostSchema;
  [QraftServiceOperationsToken]: ProductsService['calculateDilutionRateProductsCalculateDilutionRatePost'];
};
export const productsService = {
  getAllProductsGet,
  createProductsPost,
  getProductsProductIdGet,
  updateProductsProductIdPatch,
  deleteProductsProductIdDelete,
  calculateDilutionRateProductsCalculateDilutionRatePost,
} as const;
type GetAllProductsGetSchema = {
  method: 'get';
  url: '/products';
  security: ['HTTPBearer'];
};
type GetAllProductsGetParameters = undefined;
type GetAllProductsGetData = paths['/products']['get']['responses']['200']['content']['application/json'];
type GetAllProductsGetError = unknown;
type CreateProductsPostSchema = {
  method: 'post';
  url: '/products';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateProductsPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateProductsPostData = paths['/products']['post']['responses']['201']['content']['application/json'];
type CreateProductsPostError = paths['/products']['post']['responses']['422']['content']['application/json'];
type CreateProductsPostBody = paths['/products']['post']['requestBody']['content']['application/json'];
type GetProductsProductIdGetSchema = {
  method: 'get';
  url: '/products/{product_id}';
  security: ['HTTPBearer'];
};
type GetProductsProductIdGetParameters = paths['/products/{product_id}']['get']['parameters'];
type GetProductsProductIdGetData =
  paths['/products/{product_id}']['get']['responses']['200']['content']['application/json'];
type GetProductsProductIdGetError =
  paths['/products/{product_id}']['get']['responses']['422']['content']['application/json'];
type UpdateProductsProductIdPatchSchema = {
  method: 'patch';
  url: '/products/{product_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateProductsProductIdPatchParameters = paths['/products/{product_id}']['patch']['parameters'];
type UpdateProductsProductIdPatchData =
  paths['/products/{product_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateProductsProductIdPatchError =
  paths['/products/{product_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateProductsProductIdPatchBody =
  paths['/products/{product_id}']['patch']['requestBody']['content']['application/json'];
type DeleteProductsProductIdDeleteSchema = {
  method: 'delete';
  url: '/products/{product_id}';
  security: ['HTTPBearer'];
};
type DeleteProductsProductIdDeleteParameters = paths['/products/{product_id}']['delete']['parameters'];
type DeleteProductsProductIdDeleteData = null;
type DeleteProductsProductIdDeleteError =
  paths['/products/{product_id}']['delete']['responses']['422']['content']['application/json'];
type DeleteProductsProductIdDeleteBody = undefined;
type CalculateDilutionRateProductsCalculateDilutionRatePostSchema = {
  method: 'post';
  url: '/products/calculate_dilution_rate';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CalculateDilutionRateProductsCalculateDilutionRatePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CalculateDilutionRateProductsCalculateDilutionRatePostData =
  paths['/products/calculate_dilution_rate']['post']['responses']['200']['content']['application/json'];
type CalculateDilutionRateProductsCalculateDilutionRatePostError =
  paths['/products/calculate_dilution_rate']['post']['responses']['422']['content']['application/json'];
type CalculateDilutionRateProductsCalculateDilutionRatePostBody =
  paths['/products/calculate_dilution_rate']['post']['requestBody']['content']['application/json'];
